import type { RouteRecordRaw } from 'vue-router';
import { RouterView } from 'vue-router';

const routes: RouteRecordRaw = {
  name: 'MyThesisProposalRoot',
  path: 'thesis_proposal',
  redirect: { name: 'ThesisProposalRoot' },
  component: () => import('layouts/ThesisProposalLayout.vue'),
  children: [
    {
      name: 'ThesisProposalRoot',
      path: 'proposal',
      redirect: { name: 'ThesisProposal' },
      meta: {
        authz: ({ roles }) =>
          roles['ROLE_STUDENT'] && roles['ROLE_THESIS_STUDENT'],
      },
      component: RouterView,
      children: [
        {
          name: 'ThesisProposal',
          path: '',
          component: () => import('pages/thesisProposal/ProposalListPage.vue'),
          meta: {
            authz: ({ roles }) => {
              return roles['ROLE_STUDENT'] && roles['ROLE_THESIS_STUDENT'];
            },
          },
        },
        {
          name: 'ThesisProposalEdit',
          path: ':thesisId/edit',
          component: () => import('pages/thesisProposal/EditPage.vue'),
          meta: {
            authz: ({ roles }) =>
              roles['ROLE_STUDENT'] && roles['ROLE_THESIS_STUDENT'],
            breadcrumb: [
              { icon: 'home', label: 'My Thesis', to: { name: 'MyThesis' } },
              { icon: 'edit', label: 'Edit' },
            ],
          },
        },
        {
          name: 'ThesisProposalRevisionDetails',
          path: ':thesisId/revision',
          component: () =>
            import('pages/thesisProposal/RevisionDetailsPage.vue'),
          meta: {
            authz: ({ roles }) =>
              roles['ROLE_STUDENT'] && roles['ROLE_THESIS_STUDENT'],
          },
        },
      ],
    },
    {
      name: 'CreateThesisProposal',
      path: '/thesis_proposal/study_plan/:userProgramId/create_thesis',
      component: () => import('pages/thesisProposal/CreatePage.vue'),
      meta: {
        breadcrumb: [
          {
            label: 'My Thesis',
            icon: 'home',
            to: { name: 'MyThesis' },
          },
          {
            label: 'Submit thesis proposal',
            to: { name: 'CreateThesisProposal' },
          },
        ],
      },
    },
  ],
};

export const thesisProposalRoutes = routes;
